<template>
	<div>
		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>Payment information</h1></v-list-item-title>
					<v-list-item-subtitle class="text-center text-wrap">Where should we deposit your payments?</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
			<locum-bank-details-form :solo="false"></locum-bank-details-form>
		</v-card-text>
	</div>
</template>

<script>
import store from '@/store';
//locumBankDetailsForm
import locumBankDetailsForm from '@/components/locum/profile/BankDetailsForm.vue';

export default {
	components: {
		locumBankDetailsForm,
	},
	data: () => ({
		idfile: null,
		step: 'banking-step',
	}),
	created() {
		window.scrollTo(0, 0);
	},

	methods: {
		checkStep(user) {
			const { account_holder, account_number, account_type, bank_name, branch_code, tax_number } = user.payment_info;
			if (
				account_holder?.length > 1 &&
				account_number?.length > 4 &&
				account_type?.length >= 1 &&
				bank_name?.length > 1 &&
				branch_code?.length > 2 &&
				tax_number?.length > 3
			) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return true;
			}
		},
		getStep() {
			return 'banking-step';
		},
		getText() {
			return 'payment';
		},
	},
};
</script>
